import API from './base';

const version = 'v1';
const user = '/user';

export default {
  getUserData() {
    return API.get(`${version}${user}`);
  },

  setUserData(payload) {
    return API.put(`${version}${user}`, payload);
  },

  setDataForInsurance(payload) {
    return API.put(`${version}${user}/insurance`, payload);
  },

  disableUser() {
    return API.delete(`${version}${user}`);
  },
};
